import React, { useEffect, useState, useMemo } from "react";
import { CircularProgress } from "@mui/material";
import Swal from "sweetalert2";
import DynamicForm from "../../../data/Axios/DynamicForm";
import {
  generateAndExecuteMutation,
  graphqlQuery,
} from "../../../data/Axios/DynamicService";
import { companyManagementUrl, setupManagementUrl } from "../../../config";
import { allSubscriptionPlans } from "../../../data/Axios/queries";

const base_url = companyManagementUrl.uri;
const setup_url = setupManagementUrl.uri;

const CompanyForm = (props) => {
  const decodedToken = JSON.parse(localStorage.getItem("decodedToken"));
  const userId = parseInt(decodedToken.Id);

  const [subscriptionsData, setSubscriptionsData] = useState([]);
  const [loading, setLoading] = useState(true);

  // Fetch subscription plans
  useEffect(() => {
    async function fetchAllData() {
      try {
        const subscriptionsDataResponse = await graphqlQuery(
          allSubscriptionPlans,
          setup_url
        );
        if (subscriptionsDataResponse) {
          setSubscriptionsData(subscriptionsDataResponse);
        }
      } catch (error) {
        console.error("Error fetching subscriptions:", error);
      } finally {
        setLoading(false);
      }
    }
    fetchAllData();
  }, []);

  const subscriptionsOptions = useMemo(() => {
    return subscriptionsData.map((s) => ({
      value: s.id,
      label: s.plan,
    }));
  }, [subscriptionsData]);

  // ==================== STEPS ====================
  const steps = useMemo(() => [
    {
      stepLabel: "Basic Information",
      stepDescription: "Company Details",
      icon: "assignment_ind",
      fields: ["companyName","phone", "address" ,"tagline","subscriptionId"],
    },
    // {
    //   stepLabel: "Contact Details",
    //   stepDescription: "Email and contact information",
    //   icon: "contact",
    //   fields: [ "phone"],
    // },
    // {
    //   stepLabel: "Email Configuration",
    //   stepDescription: "Email server settings",
    //   icon: "settings",
    //   fields: ["emailClient", "emailClientPortNumber"],
    // },
    // {
    //   stepLabel: "Address & Legal",
    //   stepDescription: "Physical address and tax information",
    //   icon: "work",
    //   fields: ["address", "poBox", "pinVat", "website"],
    // },
    // {
    //   stepLabel: "Branding",
    //   stepDescription: "Company branding details",
    //   icon: "person",
    //   fields: ["tagline"],
    // },
  ], []);

  // ==================== FIELDS ====================
  const fields = useMemo(() => [
    {
      name: "companyName",
      label: "Company Name",
      type: "text",
      gridColumn: "span 2",
      required: true,
    },
  
    // {
    //   name: "companyEmail",
    //   label: "Company Email",
    //   type: "email",
    //   gridColumn: "span 2",
    //   required: true,
    // },
    // {
    //   name: "contactEmail",
    //   label: "Contact Email",
    //   type: "email",
    //   gridColumn: "span 2",
    // },
    // {
    //   name: "contactEmailPassword",
    //   label: "Contact Email Password",
    //   type: "password",
    //   gridColumn: "span 2",
    // },
    // {
    //   name: "emailDisplayName",
    //   label: "Email Display Name",
    //   type: "text",
    //   gridColumn: "span 2",
    // },
    {
      name: "phone",
      label: "Phone",
      type: "text",
      gridColumn: "span 2",
    },
    // {
    //   name: "mobile",
    //   label: "Mobile",
    //   type: "text",
    //   gridColumn: "span 1",
    // },
    // {
    //   name: "email",
    //   label: "General Email",
    //   type: "email",
    //   gridColumn: "span 2",
    // },
    // {
    //   name: "emailClient",
    //   label: "Email Client (SMTP)",
    //   type: "text",
    //   gridColumn: "span 2",
    // },
    // {
    //   name: "emailClientPortNumber",
    //   label: "Port Number",
    //   type: "number",
    //   gridColumn: "span 1",
    // },
    {
      name: "address",
      label: "Address",
      type: "text",
      gridColumn: "span 2",
    },
    // {
    //   name: "poBox",
    //   label: "P.O Box",
    //   type: "text",
    //   gridColumn: "span 1",
    // },
    // {
    //   name: "pinVat",
    //   label: "PIN / VAT Number",
    //   type: "text",
    //   gridColumn: "span 1",
    // },
    // {
    //   name: "website",
    //   label: "Website",
    //   type: "text",
    //   gridColumn: "span 2",
    // },
    {
      name: "tagline",
      label: "Tagline",
      type: "text",
      gridColumn: "span 2",
    },
      {
      name: "subscriptionId",
      label: "Subscription Plan",
      type: "select",
      options: subscriptionsOptions,
      gridColumn: "span 2",
      required: true,
    },
  ], [subscriptionsOptions]);

  // ==================== INITIAL VALUES ====================
  const initialValues = {
    companyName: props.data?.companyName || "",
    // companyEmail: props.data?.companyEmail || "",
    // contactEmail: props.data?.contactEmail || "",
    // contactEmailPassword: props.data?.contactEmailPassword || "",
    // emailDisplayName: props.data?.emailDisplayName || "",
    // emailClient: props.data?.emailClient || "",
    // emailClientPortNumber: props.data?.emailClientPortNumber || "",
    subscriptionId: props.data?.subscriptionId || "",
    address: props.data?.address || "",
    // poBox: props.data?.poBox || "",
    phone: props.data?.phone || "",
    // mobile: props.data?.mobile || "",
    // email: props.data?.email || "",
    // website: props.data?.website || "",
    // pinVat: props.data?.pinVat || "",
    tagline: props.data?.tagline || "",
    createdBy: props.data?.createdBy || userId,
    updatedBy: userId,
  };

  // ==================== SUBMIT HANDLER ====================
  const handleSubmit = async (values, { setSubmitting }) => {
    try {
      const mutationData = {
        ...values,
        updatedBy: userId,
        ...(props.isEditing ? { id: props.data.id } : { createdBy: userId }),
      };

      const response = await generateAndExecuteMutation(
        props.isEditing ? "updateCompany" : "createCompany",
        mutationData,
        props.isEditing ? "updatedCompany" : "newCompany",
        base_url
      );

      if (Object.values(response)[0] != null) {
        props.onClose();
        props.onAction();
        Swal.fire({
          icon: "success",
          title: "Success!",
          text: `Company ${props.isEditing ? "updated" : "created"} successfully.`,
        });
      }
    } catch (error) {
      console.error(error);
      Swal.fire({
        icon: "error",
        title: "Error!",
        text: "An error occurred while processing your request.",
      });
    } finally {
      setSubmitting(false);
    }
  };

  if (loading) {
    return <CircularProgress />;
  }

  return (
    <DynamicForm
      initialValues={initialValues}
      fields={fields}
      steps={steps}
      onSubmit={handleSubmit}
      title={props.isEditing ? "Edit Company" : "Create Company"}
      subtitle={
        props.isEditing
          ? "Update company information"
          : "Fill out the form to create a new company"
      }
    />
  );
};

export default CompanyForm;